import axios from 'axios';
import notify from 'devextreme/ui/notify';

// --- Instancia de Axios ---
// Se crea una instancia de Axios para tener una configuración centralizada.
const apiClient = axios.create({
  // DEBES configurar esta URL para que apunte a tu backend.
  // Es recomendable usar variables de entorno.
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// --- Interceptor de Petición (Request) ---
// Se ejecuta ANTES de que cada petición sea enviada.
// Su trabajo es añadir el token de autenticación a las cabeceras.
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// --- Interceptor de Respuesta (Response) ---
// Se ejecuta DESPUÉS de recibir una respuesta.
// Maneja centralizadamente los errores de autenticación (401).
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error('Error de autenticación. Redirigiendo al login.');
      
      // Notificación
      notify?.('No está autorizado.', 'danger', 2000);

      // Limpiar storage
      localStorage.clear();

      // Redirigir si no está en login
      if (window.location.pathname !== '/') {
        window.location.replace('/');
      }
    }
    return Promise.reject(error);
  }
);


// --- Función Específica de la API para Login con Nomina ---
/**
 * Realiza la petición de login al endpoint '/api/Usuarios/LoginNomina'.
 * Guarda toda la respuesta en localStorage.
 * @param {string} nomina - La nómina del usuario.
 * @param {string} password - La contraseña del usuario.
 * @returns {Promise<object>} La data de la respuesta del servidor.
 */
export const loginNomina = async (nomina: string, password: string) => {
  try {
    // Esta es la llamada real al backend.
    const { data } = await apiClient.post('/api/Usuarios/LoginDual', {
      correo: null,
      nomina: nomina,
      password: password
    });

    // Si la llamada es exitosa y devuelve datos, los guardamos en localStorage.
    if (data) {
      // Guardamos el objeto completo de datos del usuario como un string JSON.
      localStorage.setItem('userData', JSON.stringify(data));

      // También guardamos el token de acceso por separado.
      if (data.token) {
        localStorage.setItem('accessToken', data.token);
      }
    }

    // Devolvemos los datos para que el componente pueda usarlos.
    return data;
  } catch (error) {
    // Si hay un error, lo relanzamos para que el componente lo maneje.
    throw error;
  }
};
export const login365 = async (correo: string) => {
  try {
    // Esta es la llamada real al backend.
    const { data } = await apiClient.post('/api/Usuarios/LoginDual', {
      correo: correo,
      nomina: null,
      password: null
    });

    // Si la llamada es exitosa y devuelve datos, los guardamos en localStorage.
    if (data) {
      // Guardamos el objeto completo de datos del usuario como un string JSON.
      localStorage.setItem('userData', JSON.stringify(data));

      // También guardamos el token de acceso por separado.
      if (data.token) {
        localStorage.setItem('accessToken', data.token);
      }
    }

    // Devolvemos los datos para que el componente pueda usarlos.
    return data;
  } catch (error) {
    // Si hay un error, lo relanzamos para que el componente lo maneje.
    throw error;
  }
};

// --- Exportación por defecto ---
// Esta es la línea clave que soluciona el error.
// Exportamos la instancia de apiClient para que otros archivos puedan usarla.
export default apiClient;
